import { Injectable } from '@angular/core';
import { CacheService } from 'core';

@Injectable({
  providedIn: 'root'
})
export abstract class TmxUtilityService {
    checkTabPermission(tab) {
        var EntityId = 0;
        var EntityObj = {};
        var obj = JSON.parse(localStorage.getItem('LoggedInUserPrivileges')).tabs;
        //var TabEntityMapping = CacheService.get('TabEntityMapping');
    

        for (var property in obj) {
            if (obj[property].id == tab.TabId) {
                EntityObj = obj[property];
                if (EntityObj) {
                    return EntityObj['privileges'].hasOwnProperty('View');
                }
            }
        }
        return false;
    }
    checkPermission(entity, previlegeName) {
        const  alwaysAllowedMenus = ['ProfileLink', 'logout'];
        if (alwaysAllowedMenus.indexOf(entity) > -1) {
            return true;
        }
        if (!previlegeName) { // If previlege name is not defined then check view previlege
            previlegeName = 'View';
        }
        const checkEntity = JSON.parse(localStorage.getItem('LoggedInUserPrivileges')).entities[entity];
        if (checkEntity) {
            return checkEntity.privileges.hasOwnProperty(previlegeName); //Check if key with the previlegeName is there in privileges object
        }
        return false;


    }


}
